var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.85954 22.3015L13.0103 11.1507L1.85954 2.47955e-05L-5.72205e-06 1.85826L9.29379 11.1507L-5.72205e-06 20.4432L1.85954 22.3015Z",
    fill: "url(#paint0_linear_0_3291)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9931 22.3015L22.1438 11.1507L10.9931 2.47955e-05L9.13354 1.85826L18.4273 11.1507L9.13354 20.4432L10.9931 22.3015Z",
    fill: "url(#paint1_linear_0_3291)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8493 22.3015L32 11.1507L20.8493 2.47955e-05L18.9897 1.85826L28.2835 11.1507L18.9897 20.4432L20.8493 22.3015Z",
    fill: "url(#paint2_linear_0_3291)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_3291",
    x1: 16.088,
    y1: 0.0000290095,
    x2: -15.7033,
    y2: 0.0000290095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3333FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_3291",
    x1: 25.2215,
    y1: 0.0000290095,
    x2: -6.56971,
    y2: 0.0000290095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3333FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_3291",
    x1: 35.0777,
    y1: 0.0000290095,
    x2: 3.2865,
    y2: 0.0000290095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3333FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleArrows);
export default __webpack_public_path__ + "static/media/multiple-arrows.5cfca3093c88910fc932bb9b867c9331.svg";
export { ForwardRef as ReactComponent };